import { useCallback, useState } from 'react';
import { getAuthEmail } from '../services/api';
import { loadCameraStatusFilter, saveCameraStatusFilter } from '../utils/cameraStatusFilter';

/**
 * ТЗ V5 №14: выбранные группы состояния камер для локации roomId.
 * Сохраняется сразу после каждого изменения; при смене локации или
 * пользователя выбор перечитывается из его записи, а не наследуется.
 */
const useCameraStatusFilter = (roomId) => {
  const userKey = getAuthEmail();
  const scope = `${userKey}|${roomId}`;
  const [state, setState] = useState(() => ({ scope, groups: loadCameraStatusFilter(userKey, roomId) }));

  let groups = state.groups;
  if (state.scope !== scope) {
    groups = loadCameraStatusFilter(userKey, roomId);
    setState({ scope, groups });
  }

  const setGroups = useCallback((next) => {
    saveCameraStatusFilter(userKey, roomId, next);
    setState({ scope, groups: next });
  }, [userKey, roomId, scope]);

  return [groups, setGroups];
};

export default useCameraStatusFilter;
